import { AbstractControl, ValidationErrors } from '@angular/forms';
import { PackageType } from 'src/interfaces/medicine';

/** Ensures the control holds a selected PackageType object, not free text. */
export function packageTypeSelectedValidator(control: AbstractControl): ValidationErrors | null {
  const value: PackageType | string | null = control.value;

  if (!value || typeof value !== 'object' || typeof value.id !== 'number') {
    return { packageTypeRequired: true };
  }

  return null;
}
